import { Box, Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import WarningConflict from 'assets/images/pages/warning-icon.svg';

interface IProps {
    onClose: any;
    data?: any;
    onSave?: any;
}
export default function ConflictDeploymentModal({ onClose, data, onSave }: IProps) {
    const handleConfirm = async () => {
        if (onSave) await onSave();
        onClose();
    };
    return (
        <Box className="warning-conflict-modal">
            <Card variant="outlined">
                <CardContent className="card-content">
                    <div className="icon">
                        <img src={WarningConflict} alt="warning" />
                    </div>
                    <div className="title">
                        <Typography sx={{ fontSize: 20, fontWeight: 600, color: '#222222' }}>Warning!</Typography>
                        <Typography variant="body2" sx={{ mb: 0, color: '#555555', fontWeight: 400 }}>
                            Staff already has deployment plan
                        </Typography>
                    </div>
                </CardContent>
                <CardContent className="content">
                    <Typography variant="body2" sx={{ mb: 2, color: '#222222' }}>
                        The staff <strong>{data?.nameStaff}</strong> has already been deployment for the timeframe{' '}
                        <strong>{data?.timeframe}</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ mb: 2, color: '#ff0000' }}>
                        Are you sure you want to continue?
                    </Typography>
                </CardContent>
                <CardActions sx={{ justifyContent: 'end' }}>
                    <Button variant="outlined" onClick={onClose} style={{ border: '1px solid #3f51b5', color: '#3f51b5' }}>
                        No
                    </Button>
                    <Button variant="contained" onClick={handleConfirm} style={{ backgroundColor: '#3f51b5' }}>
                        Yes
                    </Button>
                </CardActions>
            </Card>
        </Box>
    );
}
